import React, { useEffect, useState } from 'react'
import axios from 'axios'
import socket from '../Components/socket'
import { apiRequest } from '../../apiService/allApi'

const Referralhis = () => {
  const [user, setUser] = useState()
  const [isLoading, setIsLoading] = useState(false)

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {

    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++ 

  const role = async () => {
    socket.emit('getprofile')

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    // await axios
    // .get(baseUrl+`me`, { headers })

    const res = await apiRequest(`me`, "GET", null, headers)
    // .then(res => {
    setUser(res.data)

    Allgames(res.data.referral_code)
    // window.location.reload()
    // })
  }

  const [cardData, setGame] = useState([])
  // console.log(cardData)

  const Allgames = async id => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    setIsLoading(true)
    // await axios
    //   .get(baseUrl+`referral/code/winn/${id}`, {
    //     headers
    //   })

    const res = await apiRequest(`referral/code/winn/${id}`, "GET", null, headers)
    // .then(res => {
    setGame(res.data)
    // console.log(res.data);
    setIsLoading(false)
    // })
  }

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const time = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    return `${newDate}, ${time}`;
  };


  useEffect(() => {
    role()
    //eslint-disable-next-line
  }, [])

  if (cardData == undefined) {
    return null
  }

  return (
    <div>
      <div className='mt-1 Orher_page_main_section   Orher_page_main_section bgbox '>
        <div>
          {isLoading ? (
            <div className='loaderReturn' style={{ zIndex: '99' }}>
              <img
                src={'/images/LandingPage_img/loader1.gif'}
                style={{ width: '100%' }}
              />
            </div>
          ) : cardData && cardData?.length == 0 ? (
            <div className='text-center not_found_box_main'>
              <img
                src='./images/not-found.gif'
                alt='no data'
              />
              <div className='mt-2'>
                <h3 className='font-weight-bold'>No Referral History</h3>
                <p>You have no referral history yet.</p>
              </div>
            </div>
          ) : (
            cardData &&
            cardData.map(card => {
              return (
                <div className="game-card-split-banner" key={card?._id}>

                  {/* HEADER BANNER */}
                  <div className="status-header-banner status-win">
                    <b className="status-text">REFERRAL EARNING</b>
                  </div>

                  {/* BODY */}
                  <div className="card-body-content">

                    {/* LEFT SIDE */}
                    <div className="details-left-column">

                      {/* REFERRED PERSON */}
                      <p className="detail-label">
                        Earned From:
                        <span className="value-emphasized ml-1">
                          {card?.earned_from?.Name}
                        </span>
                      </p>

                    </div>

                    {/* RIGHT SIDE → Amount + Balance */}
                    <div className="details-right-column">

                      <div className="d-flex justify-content-end align-items-center">
                        <picture className="ml-1 mb-1">
                          <img
                            height="21px"
                            width="21px"
                            src={process.env.PUBLIC_URL + '/rupee.png'}
                            alt="rupee"
                          />
                        </picture>
                        <h5 className="pl-2 mb-0 text-success font-weight-bold">
                          +{card?.amount}
                        </h5>
                      </div>

                      {/* CLOSING BAL */}
                      <p className="closingbl mt-2">
                        Cl Bal:
                        <b className="ml-1">{card?.closing_balance.toFixed(2)}</b>
                      </p>

                    </div>
                  </div>

                  {/* SEPARATOR */}
                  <hr className="card-separator" />

                  {/* FOOTER */}
                  <div className="card-footer-date">
                    <span className="icon-date">📅</span>
                    <p className="date-info-line">
                      {dateFormat(card?.createdAt).split(',')[0]}
                      <span className="time-info-line">
                        @{dateFormat(card?.createdAt).split(',')[1]}
                      </span>
                    </p>
                  </div>

                </div>
              );
            })
          )}
        </div>
      </div>

    </div>
  )
}

export default Referralhis
